import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import PageWrapper from "../../components/layout/page/PageWrapper";
import PageHeader from "../../components/layout/page/PageHeader";
import BackButton from "../../components/buttons/back/BackButton";

import "./AboutPage.css";

const AboutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Katch | About";
  }, []);

  return (
    <PageWrapper size="md">
      <br />
      <br />

      <BackButton onClick={() => navigate(-1)} />

      <br />
      <br />

      <PageHeader
        title="About Katch"
        subTitle="The Platform Powering Sports Content."
      />

      <div className="about-page">
        <section className="about-page__section">
          <h2>Stream. Share. Connect.</h2>

          <p>
            Katch is a sports technology platform that empowers sports
            communities to stream, share, manage and monetise their content.
          </p>

          <p>
            From live sporting events and match replays to short videos and
            photo albums, Katch brings sports content together in one place.
          </p>
        </section>

        <section className="about-page__section">
          <h2>What We Do</h2>

          <p>
            We provide creators, clubs, teams and athletes with tools to publish
            and manage sports content, connect with their communities and make
            their content accessible to the people who matter.
          </p>

          <p>
            With creator channels, groups, content sharing and monetisation
            tools, Katch makes it easier to manage sports media in one platform.
          </p>
        </section>

        <section className="about-page__section">
          <h2>Our Vision</h2>

          <p>
            To build a platform where sports communities can create, discover
            and share content while giving creators greater control over how
            their content is managed and monetised.
          </p>
        </section>

        <div className="about-page__footer">
          <p>Every game has a story worth sharing.</p>
        </div>
      </div>
    </PageWrapper>
  );
};

export default AboutPage;
